import type { ServerBuildItem } from "@investhinks/api-client";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Alert } from "reactstrap";

import { connectorsEndpoints } from "../../api";

/**
 * Admin warnings on the main dashboard for the native connector: MetaTrader server builds nobody has verified, and
 * fallback/error incidents of the last 24 hours that nobody acknowledged. Both fail silently.
 */
const ServerBuildAlert: React.FC = () => {
  const [pending, setPending] = useState<ServerBuildItem[]>([]);
  const [incidentCount, setIncidentCount] = useState(0);

  useEffect(() => {
    let cancelled = false;
    void (async () => {
      try {
        const result = await connectorsEndpoints.listServerBuilds();
        if (!cancelled) setPending(result.builds.filter((row) => row.status === "NEW" && !row.acknowledgedAt));
      } catch {
        // the warning is a convenience: never disturb the dashboard
      }
    })();
    void (async () => {
      try {
        const result = await connectorsEndpoints.listIncidents({ since: new Date(Date.now() - 24 * 3600 * 1000).toISOString() });
        if (!cancelled) setIncidentCount(result.unacknowledgedAttentionCount);
      } catch {
        // same: silent
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const [first, ...rest] = pending;
  return (
    <>
      {first && (
        <Alert color="warning" className="d-flex align-items-center" data-testid="server-build-alert">
          <i className="fas fa-exclamation-triangle mr-2" />
          <span>
            <strong>
              New MetaTrader server build detected: {first.server} build {first.build}
            </strong>
            {rest.length > 0 ? ` (and ${rest.length} more)` : ""} — <Link to="/connectors">review native connector</Link>
          </span>
        </Alert>
      )}
      {incidentCount > 0 && (
        <Alert color="danger" className="d-flex align-items-center" data-testid="native-incident-alert">
          <i className="fas fa-exclamation-circle mr-2" />
          <span>
            <strong>
              Native connector: {incidentCount} fallback/error incident{incidentCount === 1 ? "" : "s"} in the last 24h
            </strong>{" "}
            — <Link to="/connectors">review and acknowledge</Link>
          </span>
        </Alert>
      )}
    </>
  );
};

export default ServerBuildAlert;
